import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { generateQueryParams } from "../../utils/generateQueryParams";

// NOTE: Fetch user posts
export const fetchUserPosts = createAsyncThunk(
  "jobPost/fetchUserPosts",
  async (args) => {
    const query = generateQueryParams(args);
    const response = await api.get(`jobpost/user?${query}`);
    // await new Promise((resolve) => setTimeout(resolve, 4000));
    return response.data;
  }
);

// NOTE: Delete job post
export const deleteJobPost = createAsyncThunk(
  "jobPost/deleteJobPost",
  async ({ jobPostId }) => {
    const response = await api.delete(`jobpost/${jobPostId}`);
    // await new Promise((resolve) => setTimeout(resolve, 2000));
    return response.data;
  }
);

// NOTE: Create Job Post
export const createJobPost = createAsyncThunk(
  "jobPost/createJobPost",
  async (jobData) => {
    const response = await api.post("/jobpost", jobData);
    return response.data;
  }
);

// NOTE: Get user single job post
export const getSingleUserJobPost = createAsyncThunk(
  "jobPost/getSingleUserJobPost",
  async (jobPostId) => {
    const response = await api.get(`/jobpost/user/${jobPostId}`);
    // await new Promise((resolve) => setTimeout(resolve, 5000));
    return response.data;
  }
);

// NOTE: Edit user job post
export const editJobPost = createAsyncThunk(
  "jobPost/editJobPost",
  async ({ jobData, jobPostId }) => {
    const response = await api.put(`/jobpost/${jobPostId}`, jobData);
    return response.data;
  }
);

// NOTE: Get a single Job Post
export const viewJobPost = createAsyncThunk(
  "jobpost/view",
  async ({ jobPostId }) => {
    const response = await api.get(`jobpost/${jobPostId}`);
    return response.data;
  }
);

// NOTE: Get a all Job Post
export const fetchAllJobs = createAsyncThunk(
  "tasker/fetch/allJobs",
  async (arg) => {
    const query = generateQueryParams(arg);
    const response = await api.get(`jobpost?${query}`);
    return response.data;
  }
);

// NOTE: Tasker Feed - get a single job post with matching job posts
export const fetchTaskerFeed = createAsyncThunk(
  "jobpost/fetchTaskerFeed",
  async ({ jobPostId }) => {
    // const query = generateQueryParams(args);
    const response = await api.get(`jobpost/${jobPostId}/with-matchings`);
    // await new Promise((resolve) => setTimeout(resolve, 000));
    return response.data;
  }
);

// NOTE: Get all user job posts
export const getAllUserJobPosts = createAsyncThunk(
  "jobPost/getAllUserJobPosts",
  async (params) => {
    const response = await api.get(
      `/jobpost/user?limit=${params?.limit}&offset=${params?.offset}`
    );
    return response.data;
  }
);
